module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-left-square-e2986d45.svg";